import {request} from '@tencent/ppd-base-libs';

// 拉取货源配置
export function queryBusinessesConfig() {
    const url = 'https://prom.wechatpay.com.hk/fmd_mojo/ppd_config/BusinessList/businessList.json' + '?t=' + new Date().getTime();
    return request.get(url);
}
